import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  Card,
  Row,
  Col,
  DatePicker,
  Button,
  Table,
  Form,
  Input,
  message,
  Modal,
  Space,
} from "antd";
import moment from "moment";
import { CreateAssignment, UpdateAssignment, GetAssignmentsList } from "../../redux/actions/AuthAction";

const LearnerAssignments = () => {
  const dispatch = useDispatch();
  const [assignments, setAssignments] = useState([]);
  const [assignmentsLoading, setAssignmentsLoading] = useState(false);
  const [filters, setFilters] = useState({
    startDate: null,
    endDate: null,
  });
  const [editingId, setEditingId] = useState(null);
  const [modalSubmitting, setModalSubmitting] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [form] = Form.useForm();

  const fetchAssignments = () => {
    setAssignmentsLoading(true);
    const payload = {
      startDate: filters.startDate
        ? filters.startDate.format("YYYY-MM-DD")
        : undefined,
      endDate: filters.endDate
        ? filters.endDate.format("YYYY-MM-DD")
        : undefined,
    };

    const onSuccess = (res) => {
      setAssignments(res?.data || []);
      setAssignmentsLoading(false);
    };

    const onError = (err) => {
      message.error(err);
      setAssignmentsLoading(false);
    };

    dispatch(GetAssignmentsList(payload, onSuccess, onError));
  };

  // Load list by default (like learner list page)
  useEffect(() => {
    fetchAssignments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFinish = (values) => {
    setModalSubmitting(true);
    const payload = {
      textAssignment: values.textAssignment,
      date: values.date.format("YYYY-MM-DD"),
    };

    const onSuccess = (res) => {
      message.success(res?.message || "Assignment saved successfully");
      form.resetFields();
      setEditingId(null);
      setIsModalVisible(false);
      setModalSubmitting(false);
      fetchAssignments();
    };

    const onError = (err) => {
      message.error(err);
      setModalSubmitting(false);
    };

    if (editingId) {
      dispatch(UpdateAssignment(editingId, payload, onSuccess, onError));
    } else {
      dispatch(CreateAssignment(payload, onSuccess, onError));
    }
  };

  const columns = [
    {
      title: "Text",
      dataIndex: "textAssignment",
      key: "textAssignment",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
        <Space>
          <Button
            onClick={() => {
              setEditingId(record._id);
              form.setFieldsValue({
                textAssignment: record.textAssignment,
                date: moment(record.date),
              });
              setIsModalVisible(true);
            }}
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <h2>Learner Assignments</h2>

      <Card style={{ marginBottom: 16 }}>
        <Row gutter={16}>
          {/* <Col span={8}>
            <span className="key">Start Date</span>
            <DatePicker
              style={{ width: "100%" }}
              value={filters.startDate}
              onChange={(date) => setFilters({ ...filters, startDate: date })}
              format="YYYY-MM-DD"
            />
          </Col>
          <Col span={8}>
            <span className="key">End Date</span>
            <DatePicker
              style={{ width: "100%" }}
              value={filters.endDate}
              onChange={(date) => setFilters({ ...filters, endDate: date })}
              format="YYYY-MM-DD"
            />
          </Col>
          <Col
            span={8}
            style={{
              display: "flex",
              alignItems: "flex-end",
            }}
          >
            <Button type="primary" onClick={fetchAssignments} loading={assignmentsLoading} block>
              Fetch Assignments
            </Button>
          </Col> */}
          <Col
            span={8}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              marginTop: 8,
            }}
          >
            <Button
              type="primary"
              onClick={() => {
                setEditingId(null);
                form.resetFields();
                form.setFieldsValue({
                  date: moment(),
                });
                setIsModalVisible(true);
              }}
            >
              Create Assignment
            </Button>
          </Col>
        </Row>
      </Card>

      <Table
        dataSource={assignments}
        rowKey="_id"
        columns={columns}
        loading={assignmentsLoading}
        pagination={false}
      />

      <Modal
        title={editingId ? "Edit Assignment" : "Create Assignment"}
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setEditingId(null);
          form.resetFields();
        }}
        onOk={() => form.submit()}
        confirmLoading={modalSubmitting}
        okText={editingId ? "Update" : "Create"}
      >
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Form.Item
            label="Assignment Text"
            name="textAssignment"
            rules={[
              {
                required: true,
                message: "Please enter assignment text",
              },
            ]}
          >
            <Input.TextArea rows={4} />
          </Form.Item>
          <Form.Item
            label="Date"
            name="date"
            rules={[
              {
                required: true,
                message: "Please select date",
              },
            ]}
          >
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default LearnerAssignments;


